interface AppState {
  app: any | null;
}

export const appState: AppState = {
  app: null,
};
